import { Icon } from "@iconify/react/dist/iconify.js";
import { formatDuration, formatTimeStamp, getCallDurationInSeconds } from "../../api/callData";

const ExportToCSV = ({ data, selectedRows, selectedCall }) => {
    const exportToCSV = () => {
        // Get data based on selection
        const exportData = selectedRows && selectedRows.length > 0
            ? data.filter(call => selectedRows.includes(call.id))
            : data.slice(0, 20);
        
        // Define CSV headers
        const headers = [
            'Call ID',
            'Customer Phone Number',
            'Duration',
            'Start Time',
            'Flagged',
            'Message Count',
            'User Messages',
            'Assistant Messages',
            'Average Response Time',
            'Sentiment Trend',
            'Sentiment Average',
            'Sentiment Volatility',
            'Total Duration',
            'Turns',
            'Average Message Length',
            'Topic Shifts',
            'User Engagement Score',
            'Success Score',
            'Success Status'
        ];

        // Convert data to CSV rows
        const csvRows = exportData.map(call => [
            call.id,
            call.metadata.caller_id,
            formatDuration(getCallDurationInSeconds(call)),
            formatTimeStamp(call?.metadata?.timestamp),
            call.flagged_for_review ? 'Yes' : 'No',
            call.analytics.message_count,
            call.analytics.user_messages,
            call.analytics.assistant_messages,
            call.analytics.average_response_time,
            call.analytics.sentiment_analysis.trend,
            call.analytics.sentiment_analysis.average,
            call.analytics.sentiment_analysis.volatility,
            getCallDurationInSeconds(call),
            call.analytics.interaction_metrics.turns,
            call.analytics.interaction_metrics.average_message_length,
            call.analytics.interaction_metrics.topic_shifts,
            call.analytics.interaction_metrics.user_engagement.conversation_depth,
            call.success_score || 'N/A',
            call.score_status || 'N/A'
        ]);

        // Combine headers and rows
        const csvContent = [
            headers.join(','),
            ...csvRows.map(row => row.join(','))
        ].join('\n');

        // Create and trigger download
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `call_history_export_${new Date().toISOString().split('T')[0]}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <button 
            className="whitespace-nowrap font-medium flex flex-row items-center rounded-md gap-2 p-2 button-container text-sm transition-colors"
            onClick={exportToCSV}
        >
            <Icon icon="material-symbols:file-export-rounded" className="text-xl text-accent" /> 
            {selectedCall ? '' : selectedRows && selectedRows.length > 0 
                ? `Export Selected (${selectedRows.length})` 
                : 'Export to CSV'
            }
        </button>
    );
};

export default ExportToCSV; 